<template>
  <div class="page-title">
    <v-icon>{{ icon }}</v-icon>
    <h2>
      {{ title }}
      <slot></slot>
    </h2>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    icon: {
      type: String,
      default: "mdi-home",
    },
    title: {
      type: String,
      default: "Page Title",
    },
  },
};
</script>

<style lang="scss" scoped>
    .page-title {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;

        .theme--light.v-icon {
            color: rgba(0, 0, 0, 0.9);
        }

        h2 {
            padding-left: 10px;
            font-size: 1.25rem;
            font-weight: 400;
            letter-spacing: 0.0125em;
            line-height: 1.2rem;
            word-break: break-all;
        }
    }
</style>